import { render, staticRenderFns } from "./cardFactView.vue?vue&type=template&id=30926d84"
import script from "./cardFactView.vue?vue&type=script&lang=js"
export * from "./cardFactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports